// SPDX-License-Identifier: MPL-2.0

// AES Encryption/Decryption with AES-256-GCM using random Initialization Vector + Salt
// ----------------------------------------------------------------------------------------
// the encrypted datablock is base64 encoded for easy data exchange. 
// if you have the option to store data binary save consider to remove the encoding to reduce storage size
// ----------------------------------------------------------------------------------------
// format of encrypted data - used by this example. not an official format
//
// +--------------------+-----------------------+----------------+----------------+
// | SALT               | Initialization Vector | Auth Tag       | Payload        |
// | Used to derive key | AES GCM XOR Init      | Data Integrity | Encrypted Data |
// | 64 Bytes, random   | 16 Bytes, random      | 16 Bytes       | (N-96) Bytes   |
// +--------------------+-----------------------+----------------+----------------+
//
// ----------------------------------------------------------------------------------------
// Input/Output Vars
//
// MASTERKEY: the key used for encryption/decryption. 
//            it has to be cryptographic safe - this means randomBytes or derived by pbkdf2 (for example)
// TEXT:      data (utf8 string) which should be encoded. modify the code to use Buffer for binary data!
// ENCDATA:   encrypted data as base64 string (format mentioned on top)

// load the build-in crypto functions
///////////////////////////////////////////// previous code/////////////////////////////////////////
var crypto = require('crypto');
const cryptoConfig = {
    cipherAlgorithm: 'aes-256-gcm',
    masterKey: 'ThirtyTwoBytes3$ThirtyTwoBytes3$',
    iterations: 65535,
    keyLength: 32,
    saltLength: 16,
    ivLength: 12,
    tagLength: 16,
    digest: 'sha512'
}
//try with 'sha216'
// encrypt/decrypt functions
export default  {
    encrypt: function(content) {
        const salt = crypto.randomBytes(cryptoConfig.saltLength);
        const iv = crypto.randomBytes(cryptoConfig.ivLength);
        const key = crypto.pbkdf2Sync(cryptoConfig.masterKey, salt, cryptoConfig.iterations,
        cryptoConfig.keyLength, cryptoConfig.digest);
        const cipher = crypto.createCipheriv(cryptoConfig.cipherAlgorithm, key, iv);
        const encrypted = Buffer.concat([cipher.update(content, 'utf8'), cipher.final()]);
        const tag = cipher.getAuthTag();
        // ### put the auth tag at the end of encrypted
        //const encdata = Buffer.concat([salt, iv, tag, encrypted]).toString('base64');
        const encdata = Buffer.concat([salt, iv, encrypted, tag]).toString('base64');
        
        return encdata;
    },
    decrypt(encdata){
        ///decrypt
        // base64 decoding
        const bData = Buffer.from(encdata, 'base64');

        // convert data to buffers
        const salt1 = bData.slice(0, 16);
        const iv1 = bData.slice(16, 28); 
        const text1 = bData.slice(28, bData.length - 16); 
        const tag1 = bData.slice(bData.length - 16);

        // derive key using; 32 byte key length
        // const key = crypto.pbkdf2Sync(cryptoConfig.masterkey, salt , 2145, 32, 'sha512');
        const key1 = crypto.pbkdf2Sync(cryptoConfig.masterKey, salt1, cryptoConfig.iterations,
        cryptoConfig.keyLength, cryptoConfig.digest)

        // AES 256 GCM Mode
        const decipher = crypto.createDecipheriv('aes-256-gcm', key1, iv1);
        decipher.setAuthTag(tag1);

        // encrypt the given text
        const decrypted = decipher.update(text1, 'binary', 'utf8') + decipher.final('utf8');

        return decrypted;
    }


};

